import styles from './FileUpload.module.scss';
import cx from 'classnames';
import {
  AlloyButton,
  FileInput,
  Loader,
  Modal,
  DownloadIcon,
  useModal
} from 'cat-ecommerce-alloy';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useBreakpoint } from '@app/hooks';
import useFileUploader from '../../../pages/checkout/shopping-cart/ShoppingCartPage/ShoppingCartDropZone/hooks/useFileUploader';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import ImportSavedListModalContent from '../ImportSavedListModalContent';
import { DEFAULT_ROW_VALUES } from '@app/components/pages/checkout/shopping-cart/ShoppingCartPage/constants';
import { replaceTokensInString } from '@app/utils';

const FileUpload = ({
  errorInfo,
  handleOpenImportChild,
  shoppingCartMaxItems
}) => {
  const [t] = useTranslation();
  const importSavedListTxt = t('IMPORT_SAVED_LIST');
  const downloadLabel = replaceTokensInString(t('DOWNLOAD_{0}'), '');
  const { setFieldValue, status, setStatus, values } = useFormikContext();
  const { isOpen, open, close } = useModal();
  const { handleFileUpload } = useFileUploader({
    defaultRowValues: DEFAULT_ROW_VALUES,
    errorInfo,
    setFieldValue,
    setStatus,
    shoppingCartMaxItems,
    values
  });
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);

  const handleFileInput = e => {
    handleFileUpload(e.target.files);
  };
  const handleOpenImportModal = () => {
    if (isMD) {
      open();
    } else {
      handleOpenImportChild();
    }
  };
  const extensionFiles = ['csv', 'xls', 'xlsx'];

  const sampleButton = extensionFiles.map((extension, index) => (
    <span
      key={extension}
      className={cx(
        'd-flex align-items-center',
        styles['file-upload__sample-button'],
        {
          'pe-1': index < extensionFiles.length - 1
        }
      )}
    >
      {`.${extension}`}
      <a
        className="btn btn-link btn-sm py-0 pe-0 ps-1"
        download={`sample_parts.${extension}`}
        rel="noopener noreferrer"
        target="_blank"
        href={`/wcs-static/sample_parts.${extension}`}
      >
        {t('SAMPLE')}
      </a>
      {index < extensionFiles.length - 1 ? ', ' : ''}
    </span>
  ));

  return (
    <div
      className={cx(
        'col-12 d-flex flex-column align-self-stretch p-2 mt-3 mt-lg-0 justify-content-center align-items-center',
        styles['file-upload'],
        {
          [`col-lg-5 ${styles['file-upload--small-column']}`]: !values.showNotes
        }
      )}
    >
      {status?.setIsLoadingFile ? (
        <>
          <Loader />
          <span className="text-sm u-color--DarkGray m-0 mt-3">
            {t('UPLOADING_FILE')}
          </span>
        </>
      ) : (
        <>
          {isLG && (
            <p className="exclude-global text-sm u-color--DarkGray pb-2 mb-0">
              <DownloadIcon
                title={downloadLabel}
                className={cx(
                  'me-2 pe-1 u-fill--DarkGray',
                  styles['file-upload__icon']
                )}
              />
              {t('DRAG_&_DROP')}
            </p>
          )}
          <div className="d-flex align-content-center justify-content-center w-100">
            <FileInput
              file=""
              id="quickOrderFileUpload"
              label={t('CHOOSE_A_FILE')}
              labelledBy="quickOrderFileUploadLabel"
              name="quickOrderFileUpload"
              onChange={handleFileInput}
              removeHandler={function noRefCheck() {}}
              labelClassName="d-flex align-items-center btn btn-ghost btn-lg"
              wrapperClassName={cx(
                styles['file-upload__file-input-wrapper'],
                'border-end'
              )}
            />
            <AlloyButton
              buttonType="ghost"
              size="large"
              onClick={handleOpenImportModal}
            >
              {importSavedListTxt}
            </AlloyButton>
          </div>
          <Modal
            isOpen={isOpen}
            close={close}
            contentLabel={importSavedListTxt}
            title={importSavedListTxt}
            className={`${styles['modal-height']}`}
          >
            <ImportSavedListModalContent close={close} isOpen={isOpen} />
          </Modal>
          <div className="text-sm d-flex align-items-start pt-2 position-sticky">
            ({sampleButton})
          </div>
        </>
      )}
    </div>
  );
};

FileUpload.propTypes = {
  errorInfo: PropTypes.shape({
    domain: PropTypes.string,
    path: PropTypes.string
  }),
  handleOpenImportChild: PropTypes.func,
  shoppingCartMaxItems: PropTypes.number
};

export default FileUpload;
